<div class="card card-chart common-card">
  <div class="card-header">
    <h5 class="card-category">{{cardParams.category | translate}}</h5>
    <h4 class="card-title">{{cardParams.title | translate}}</h4>
    @if (cardParams.drop) {
      <div ngbDropdown>
        <button type="button" class="btn btn-round btn-default dropdown-toggle btn-simple btn-icon no-caret" ngbDropdownToggle>
          <i [class]="'now-ui-icons ' + cardParams.drop.icon"></i>
        </button>
        <div ngbDropdownMenu class="dropdown-menu-right">
          @for (item of cardParams.drop.items; track item) {
            <button [class]="'dropdown-item ' + (item.class ? item.class : '')" type="button" (click)="item.action()">{{item.text}}</button>
          }
        </div>
      </div>
    }
  </div>
  <div class="card-body">
    <ng-content select="[body]"></ng-content>
  </div>
  <div class="card-footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
